 <div class="personalViewContainer" [ngClass]="{'is-mobile-view': isMobileView}">
     <div *ngIf="!moovWizardOpened" class="topPart">


        <div class="name-score-container">
            <div class="score-wrapper">
                <app-score *ngIf="scoreDetails != undefined && scoreDetails.isScoreDataExistsAndRelevant" 
                    [ngClass]="{'is-mobile-view': isMobileView}" 
                    [textSize]="'16px'" 
                    [isMiniScoreView]="true" 
                    [scoreValuesDetails]="scoreDetails" 
                    [backgroundColor]="'#FAFAFA'">
                </app-score>
            </div>
            <span class="myMotivations_name">{{user?.firstName}} {{user?.lastName}}</span>
        </div>


        <!-- <app-score *ngIf="isMemberInCareerProccess" [ngClass]="{'is-mobile-view': isMobileView}" [textSize]="'16px'" [isMiniScoreView]="true" [scoreValuesDetails]="scoreDetails" [backgroundColor]="'#F4F6F8'" ></app-score> -->
        <span><mat-divider class="myMotivations_divider"></mat-divider></span>
    </div>
    <div *ngIf="!moovWizardOpened" class="myMotivations_motivationsList_container" [ngClass]="{'is-mobile-view': isMobileView}">
            <div class="myMotivations_motivationsList" [ngClass]="{'is-mobile-view': isMobileView}">
                <app-motivation-ticket class="myMotivations_motivation" *ngFor="let currMotivation of myMotivations" [ngClass]="{'is-mobile-view': isMobileView}" 
                    [icon] = "currMotivation.imageUrl" 
                        [name]="currMotivation.name" 
                        [motivationColor]="currMotivation.color"
                        [score]="currMotivation.gapFactor" 
                        [trend]="currMotivation.trendData" 
                        [isUnknownScoreValue]="!currMotivation.isGapDataRelevant" 
                        [isTrendValueExists]="currMotivation.isTrendDataExists" 
                        [isTrendValueRelevant]="currMotivation.isTrendDataRelevant" 
                        [hideTrendAndScore]="false"
                        [presentEnergyLevel]="!isLimitedView && !isMemberInCareerProcess"
                        (click)="openMotivation(currMotivation.id)">
                </app-motivation-ticket>
            </div>
            <!-- <div *ngIf="isDataNotUpdatedWarning && !isForcePresentNotUpdatedData" class="teamMemberDetailsView_motviationsWarning">
                <span class="teamMemberDetailsView_motviationsWarningText">{{"teamMemberDetailsView.oldDetailsWarning" | translate}}</span>
                <button mat-flat-button class="teamMemberDetailsView_moovsSectionSelectionButton tmdv_selectedButton" (click)="forcePresentNotUpdatedData()">{{"teamMemberDetailsView.oldDetailsWarningButtonText" | translate}}</button>
            </div> -->
    </div>

    @if(!isCVDataUploaded && !isLoadingCVMetadata && !cvUploadSuccessFull){
        @if(isCVDataUploading){
            <mat-spinner [diameter]="40"></mat-spinner>
        }
        @else{    
            <claro-alert class="myMotivations_userAlert" [ngClass]="{'is-mobile-view': isMobileView}" [type]="alertTypeEnum.Info" [header]="'personal.noCVUploaded' | translate" [text]="'personal.noCVUploadedText' | translate" [presentDetailsButton]="true" [detailsButtonText]="'personal.uploadCVButtonText' | translate" (seeAlertClicked)="openSelectCVFileSeletionDialog()"></claro-alert>
        }
    }

    <app-make-moov-container *ngIf="moovWizardOpened" [presentTopBar]="false" [skipIssueSelection]="true" [selectedIssueId]="makeMoovWizardSelectedIssue" [selectedMotivationId]="makeMoovWizardSelectedMotivation" [isSelectMoovForSelf]="true" (close)="closeMakeMoovWizard()"></app-make-moov-container>
    <div *ngIf="!moovWizardOpened" class="myMotivations_bottomPart" [ngClass]="{'is-mobile-view': isMobileView}">
        <div *ngIf="userNewToResults" class="myMotivations_challengeResultsContainer" [ngClass]="{'bold' : userNewToResults}">
            <div>
                <span class="myMotivations_challengeResultsText" [ngClass]="{'bold' : userNewToResults}">
                    {{"personal.challengeResultsHeader" | translate}}
                </span>
                <button mat-button class="myMotivations_challengeResultsButton" [ngClass]="{'bold' : userNewToResults}" (click)="challengeResults()">{{"personal.challengeResultsButton" | translate}}</button>    
            </div>
            <span><mat-divider class="myMotivations_divider"></mat-divider></span>
        </div>
        <!-- <app-quick-actions *ngIf="presentMoovsForSelf" class="myMotivations_quickActions" [motivationsList]="myMotivations" [isOptionsForSelf]="true" (actionSelectedEvent)="makeDirectMoov($event)"></app-quick-actions> -->
        <div class="myMotivations_drivesInsightsContainer" [ngClass]="{'is-mobile-view': isMobileView}">
            <span class="subHeaderBold" [ngClass]="{'is-mobile-view': isMobileView}">{{'personal.drivesInsights' | translate}}</span>
            <div class="insights-content">
                <app-carousel class="insightsCarousel" [showDotsStepper]="true" [showFooterControls]="true" *ngIf="insightsRetreived" [isRTL]="isRTL" [chips]="inightsChips">
                    <ng-container *ngFor="let insight of insights">
                        <ng-container *carouselItem>
                            <div class="insightTitle" [ngClass]="{'is-mobile-view': isMobileView}">
                                {{ insight.insightType.text }}
                            </div>               
                                <div class="insightItem" *ngFor="let insightItem of insight.insights;"> 
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <mat-panel-title class="insight-short-description">
                                                <!-- <img class="motivationIcon" src="{{ motivationsImageRootFolder+insightItem.motivationId}}.svg" [ngStyle]="{'fill': colorScheme}"> -->
                                                <app-claro-icon-mat-icon class="claroIcon" [colorScheme]="motivationsService.getMotivationColor(insightItem.motivationId)" [lineHeight]="'1.2em'" [iconName]="getMotivationIconName(insightItem.motivationId)" [size]="'26px'" [fontSize]="'24px'"></app-claro-icon-mat-icon>
                                                <span class="short-description-text" [ngClass]="{'is-mobile-view': isMobileView}">{{ insightItem.shortDescription }}</span>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <div class="insights-text" [innerHtml]="insightItem.longDescription"></div>
                                    </mat-expansion-panel>
                                </div>   
                        </ng-container>
                    </ng-container>
                </app-carousel> 
            </div>
            <div *ngIf="!userNewToResults && !isB2CUser" class="myMotivations_challengeResultsContainer">
                <span><mat-divider class="myMotivations_divider"></mat-divider></span>
                <div class="myMotivations_challengeResultsTextContainer">
                    <span class="myMotivations_challengeResultsText" [ngClass]="{'bold' : userNewToResults}">
                        {{"personal.challengeResultsHeader" | translate}}
                    </span>
                    <button mat-button class="myMotivations_challengeResultsButton" [ngClass]="{'bold' : userNewToResults}" (click)="challengeResults()">{{"personal.challengeResultsButton" | translate}}</button>    
                </div>
            </div>            
        </div>
        <div class="myMotivations_actionsSection" [ngClass]="{'is-mobile-view': isMobileView}">
            <div class="contactUsContainer" [ngClass]="{'is-mobile-view': isMobileView}">
                <img class="myMotivations_downloadReportImage" src="{{imageCommonFolder}}downloadReport.svg">
                <span class="personalView_downloadReportSubHeader">{{'personal.downloadInsightsReportHeader' | gender | translate}}</span>
                <button mat-raised-button *ngIf="!isReportGenerated" class="tellUsButton" (click)="getUserInsightsReport()">{{'personal.downloadInsightsReport' | gender | translate}}</button>
                <mat-spinner [diameter]="40" *ngIf="isReportGenerated"></mat-spinner>
            </div>
            <div class="contactUsContainer" [ngClass]="{'is-mobile-view': isMobileView}">
                @if(isLoadingCVMetadata || isCVDataUploading){   
                    <mat-spinner [diameter]="40" [style.justify-self]="'center'"></mat-spinner>
                }
                @else{
                    @if(cvUploadSuccessFull || isCVDataUploaded){
                        <img class="myMotivations_contactUsImage" src="{{imageCommonFolder}}uploadSuccessful.svg">
                    }
                    @else{
                        <img class="myMotivations_contactUsImage" src="{{imageCommonFolder}}uploadCV.svg">
                    }

                    @if (!isCVDataUploaded && !cvUploadSuccessFull){
                        <span class="personalView_contactUsSubHeader">{{'personal.uploadCV' | gender | translate}}</span>
                        <span class="personalView_contactUstext" [innerHtml]="'personal.uploadCVMoreDetails' | gender | translate"></span>
                    }
                    @else if (!isCVDataUploaded && cvUploadSuccessFull){
                        <span class="personalView_contactUsSubHeader">{{'personal.CVUploaded' | translate}}</span>
                        <span class="personalView_contactUstext">{{'personal.weAreAnalyzingYourCV' | translate}}</span>
                    }
                    @else{
                        <span class="personalView_contactUsSubHeader">{{'personal.weHaveYourCV' | translate}}</span>
                        <span class="personalView_contactUstext">{{userCVMetadata?.fileName}}</span>
                    }
                    <button mat-raised-button class="tellUsButton" (click)="openSelectCVFileSeletionDialog()">{{'personal.uploadCVButtonText' | translate}}</button>
                    <input
                    type="file"
                    #cvFileInput
                    accept="application/pdf"
                    style="display: none;"
                    (change)="uploadCV($event)"/>                
                        
                }
            </div>
        </div>
    </div>
    <div *ngIf="isB2CUser && nextStepId && isDiscoveryStepCompleted" class="structuredProcess_nextStepContainer">
        <button mat-raised-button color="primary" class="structuredProcess_nextStepButton" (click)="continueToNextStep()">
            {{ 'personal.continueToNextStep' | translate }}
            <mat-icon class="structuredProcess_nextStepIcon">arrow_forward</mat-icon>
        </button>
    </div>
 </div>

